import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { useInView } from 'react-intersection-observer';
import './FeatureView.css';
import useViewport from '../useViewport';

function FeatureView() {

    const isMdOrLarger = useViewport();

    // Elements are outside the viewport causing overflow, 
    // Need to figure out how to place them inside the viewport initially while keeping the slide in animations
    const [feature1, inView1] = useInView({
        triggerOnce: true, // Only trigger once
        threshold: 0.2,
        // temporary fix to initial overflow problem
    });

    const [feature2, inView2] = useInView({
        triggerOnce: true,
        threshold: 0.2,
    });

    const [feature3n4, inView3] = useInView({
        triggerOnce: true,
        threshold: 0.2,
    });

    const [titleRef, inView4] = useInView({
        triggerOnce: true,
        threshold: 0.2,
    });

    return (
        <div className='feature-container background-primary'>
            <Container maxWidth="xl">
            <div className={`integration-title-container ${inView4 && isMdOrLarger ? 'fade-in' : ''}`} ref={titleRef}>
                    <h3 className='integration-pre-title foreground-highlight'>Benefits</h3>
                    <h1 className='integration-title text-title'>Best AR Experience</h1>
                    <h2 className='integration-subtitle text-description'>
                        For you and your customers, across platforms.
                    </h2>
                </div>
                <Grid container sx={{ py: "2em"}} spacing={6}>
                    {/* Feature 1 */}
                    <Grid item xs={12} md={4} ref={feature1} className={isMdOrLarger ? inView1 ? 'show-feature' : 'slide-left' : 'show-feature'}>
                    
                        <div className='feature-info-left'>
                            <div className='text-heading'>Effortless Photorealistic Visualizations</div>
                            <p className='feature-info-paragraph text-description'>Blankwall automatically generates 3D models from your existing product listings.<br/> No manual per-product setup, and no additional work to support new products. Show products true to scale and color in customers' spaces.</p>
                        </div>
                    </Grid>

                    <Grid item xs={12} md={8} ref={feature1} className={isMdOrLarger ? inView1 ? 'show-feature' : 'slide-right' : 'show-feature'}>
                        <div className='feature-image-normal'>
                            <img src="Feature-1.png" alt='color-accurate' className='feature-image' />
                        </div>
                    </Grid>

                    {/* Try highlighting some key words using different color to make the text less dull */}
                    {/* Maybe turn the 3 sentences into a list */}
                    {/* Feature 2 */}
                    <Grid item xs={12} md={8} sx={{ order: { xs: 2, md: 1 } }} ref={feature2} className={isMdOrLarger ? inView2 ? 'show-feature' : 'slide-left' : 'show-feature'}>
                        <div className='feature-image-reverse'>
                            <img src="Feature-2.png" alt="custom-frame" className='feature-image' />
                        </div>
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ order: { xs: 1, md: 2 } }} ref={feature2} className={isMdOrLarger ? inView2 ? 'show-feature' : 'slide-right' : 'show-feature'}>
                        <div className='feature-info-right'>
                            <div className='text-heading'>
                                Customizable <br className='sm:block hidden'/>Frames
                            </div>
                            <p className='feature-info-paragraph text-description'>Showcase your catalog with our frame presets for a stunning result. 
                            <br/><b>Have your own design?</b> Use our Custom Frame tool to create your own presets.
                            </p>
                        </div>
                    </Grid>

                </Grid>

                {/* Feature Column */}
                <Grid container sx={{ py: "2em"}}>
                    {/* No redirect */}
                    <Grid item xs={12} md={4} ref={feature3n4} sx={{order: { xs: 1, md: 1 }, paddingRight: { xs: '1rem', md:'2rem' }}} className={isMdOrLarger ? inView3 ? 'show-feature' : 'slide-left' : 'show-feature'}>
                        <div className='feature-info-column-left'>
                            <div className='text-heading'>
                                Never Leave Your Site
                            </div>
                            <p className='feature-info-paragraph text-description'>No redirecting with third-party links. No separate downloads. Your customers and assets stay with you.</p>
                            <div className='feature-image-normal'>
                                <img src="Feature-3.png" alt="custom-frame" className='feature-image' />
                            </div>
                        </div>
                    </Grid>
                    {/* Much More */}
                    <Grid item xs={12} md={4} sx={{order: { xs: 3, md: 2 }}}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', paddingY: { xs: '1rem', md: 0 } }}>
                            <a href='/contact' style={{ textDecoration: 'none', cursor: 'pointer' }} className='text-description foreground-highlight'>And Much More...</a> 
                        </div>
                    </Grid>
                    {/* Personalized Support */}
                    <Grid item xs={12} md={4} ref={feature3n4} sx={{order: { xs: 2, md: 3 }, paddingLeft: { xs: 0, md: '2rem' }, paddingRight: { xs: '1rem', md: 0 }, paddingTop: { xs: '2rem', md: 0 }}} className={isMdOrLarger ? inView3 ? 'show-feature' : 'slide-right' : 'show-feature'}>
                        <div className='feature-info-column-right'>
                            <div className='text-heading'>
                                Personalized Support
                            </div>
                            <p className='feature-info-paragraph text-description'>Connect with our dedicated team for tailored solutions and exceptional assistance.</p>
                            <div className='feature-image-normal'>
                                <img src="Feature-4.png" alt="custom-frame" className='feature-image' />
                            </div>
                        </div>
                    </Grid>

                </Grid>
            </Container>
        </div>
    )

}

export default FeatureView;